// 회사소개
export default [
  {
    path: '/:locale([en]*)?/company',
    name: 'Company',
    component: () => import('@/views/company/Index'),
    meta: {
      scroll: true,
      sitemap: {
        loc: '/company'
      }
    },
    redirect: {
      name: 'company-culture'
    },
    children: [
      {
        name: 'company-culture',
        path: 'culture',
        component: () => import('@/views/company/Culture'),
        meta: {
          // scroll: true,
          // language: false,
          parent: 'Company',
          sitemap: {
            loc: '/company/culture'
          }
        },
      },
      {
        name: 'company-history',
        path: 'history',
        component: () => import('@/views/company/History'),
        meta: {
          // scroll: true,
          // language: false,
          parent: 'Company',
          sitemap: {
            loc: '/company/history'
          }
        },
      }
    ]
  }
]
